module.exports = __webpack_public_path__ + "img/English-05.33829825.jpg";